export enum PathEnum {
    Home = '/',
    NotFound = '/not-found/',
    About = '/#about',
    Watch = '/#watch',
    Discover = '/#discover',
    YourStory = '/#your-story',
    GetInvolved = '/get-involved/',
    News = '/#news',
    Questions = '/#questions',
    Partners = '/#partners',
    PrivacyPolicy = '/privacy-policy/',
    Imprint = '/imprint/',
    Faq = '/faq/',
    ContactUs = '/contact-us/',
    SupportUs = '/support-us/',
    BecomeAVolunteer = '/become-a-volunteer/',
    ComingSoon = '/coming-soon/',
    Explore = '/i+n-explore/',
    Museum = '/i+n-museum/',
    FilmSubmission = '/film-submission/',
}
